import { useEffect, useState } from 'react';
import { cookieConsent } from '@/lib/cookieConsent';

/**
 * Master switch for AdSense placements. Keep false until cookie consent,
 * valid ad units, and AdSense approval are ready — see ADSENSE-REAPPLICATION-PLAN.md.
 */
export const isAdsEnabled = (): boolean =>
  import.meta.env.VITE_ENABLE_ADS === 'true';

export const shouldRenderAds = (): boolean =>
  isAdsEnabled() && cookieConsent.hasConsent();

/**
 * Reactive gate for ad UI: enabled flag + cookie consent.
 * Remounts after Accept/Reject without a full page reload.
 */
export const useShouldRenderAds = (): boolean => {
  const [shouldRender, setShouldRender] = useState(shouldRenderAds);

  useEffect(() => {
    const sync = () => setShouldRender(shouldRenderAds());
    sync();
    window.addEventListener('cookieConsentAccepted', sync);
    window.addEventListener('cookieConsentRejected', sync);
    return () => {
      window.removeEventListener('cookieConsentAccepted', sync);
      window.removeEventListener('cookieConsentRejected', sync);
    };
  }, []);

  return shouldRender;
};
